import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

const firebaseConfig = {
  apiKey: "AIzaSyAl4r-ETxl2WjaGlsYvS6sN1esfwAQIuEs",
  authDomain: "farmacia-subito.firebaseapp.com",
  projectId: "farmacia-subito",
  storageBucket: "farmacia-subito.firebasestorage.app",
  messagingSenderId: "485075313623",
  appId: "1:485075313623:web:72401f0e04d8fcb80fa192"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const messaging = getMessaging(app);

export const requestNotificationPermission = async (farmaciaId) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission === 'granted') {
      const token = await getToken(messaging, {
        vapidKey: 'BLvztUjmKRJfT0sEIDNtbZMRRHEsJfvXXLH8khBa8IUQBwlteItHS2xBhCO9GrWJxbNx7l6y-EGoJv_Qx59gqcc'
      });
      
      console.log('Token FCM Farmacia:', token);

      // Salva token in Firestore
      if (farmaciaId && token) {
        const { doc, updateDoc } = await import('firebase/firestore');
        await updateDoc(doc(db, 'farmacie', farmaciaId), {
          fcmToken: token,
          fcmTokenUpdatedAt: new Date().toISOString()
        });
        console.log('Token salvato in Firestore ✅');
      }

      return token;
    } else {
      console.log('Permesso notifiche negato');
    }
  } catch (error) {
    console.error('Errore permesso notifiche:', error);
  }
};

onMessage(messaging, (payload) => {
  console.log('Notifica ricevuta:', payload);
  const audio = new Audio('data:audio/wav;base64,UklGRnoGAABXQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQoGAACBhYqFbF1fdJivrJBhNjVgodDbq2EcBj+a2/LDciUFLIHO8tiJNwgZaLvt559NEAxQp+PwtmMcBjiR1/LMeSwFJHfH8N2QQAoUXrTp66hVFApGn+DyvmwhBSuBzvLZiTYHGGm98OScTgwOUKXh8LhjHAU2kdXzzn0vBSd+zPLaizsIFmS57OihUBELTKXh8bllHgU1jtTx0IU2Bhp3y/LajDgIF2W56+mjTxEKTqzn8bhjHQU2jdPx0YY2Bhp3zPLajDcIF2S46+mjThEJT63p8bpkHQU2jdTx0YU1Bhp4y/LajDgIF2S56+mjUBEJTq3p8bljHQU2jdPx0YY2Bhp3y/LbjDcIF2S56+mjTxEJTq3o8bpkHQU3jdTx0YU1Bxp4y/LajDgIF2S56+mjUBEJTqzo8bpkHQU3jdTx0YU1Bhp4y/LbjDgIF2O56+mjTxEJT6zo8bljHQU3jdPx0YY2Bhp4y/LbjDcIF2S56+mjTxEJTqzo8bpkHQU3jdTx0YY1Bhp4y/LajDgIF2O56+mjTxEKTqzp8bljHQU3jdPx0YY2Bhp4y/LbjDcIF2S56+mjTxEJTqzo8bpkHQU2jdTx0YU1Bhp4y/LajDgIF2O56+mjUBEJTqzp8bljHQU3jdPx0YY2Bhp4y/LbjDcIF2S56+mjTxEJTqzo8bpkHQU3jdTx0YU1Bhp4y/LajDgIF2S56+mjTxEJTqzo8bljHQU3jdPx0YY2Bhp4y/LbjDgIF2S56+mjTxEJTqzo8bljHAU3jdPx0YY2Bhp4y/LbjDcIF2W56+mjTxEJTqzo8bljHAU3jdPx0YY2Bhp4y/LbjDcIF2S56+mjTxEJT6zo8bpkHQU3jdPx0YU2Bhp4y/LajDcIF2S56+mjTxEJTqzo8bpkHQU3jdTx0YY1Bhp4y/LajDgIF2S56+mjTxEJTqzo8bpkHQU2jdTx0YU1Bhp4y/LbjDgIF2S56+mjTxEJTqzo8bpkHQU3jdTx0YU2Bhp4y/LbjDcIF2S56+mjTxEKTqzo8bpkHQU2jdTx0YY1Bhp4y/LajDgIF2S56+mjTxEJTqzo8bpkHQU3jdPx0YY2Bhp4y/LbjDcIF2S56+mjTxEJTq');
  audio.play().catch(() => {});
  new Notification(payload.notification.title, {
    body: payload.notification.body,
    icon: '/logo192.png'
  });
});